const isProduction = process.env.NODE_ENV === 'production' && process.env.CLOUD_ENV === 'production';
const isTest = process.env.CLOUD_ENV === 'test';
const isDev = process.env.CLOUD_ENV === 'develop';

let reolinkApiUrl = '';
if ( isProduction ) {

    reolinkApiUrl = 'https://reolink.com';

} else if ( isTest ) {

    reolinkApiUrl = 'https://reolink.review';

} else if ( isDev ) {

    reolinkApiUrl = 'https://reolink.dev';

} else {

    reolinkApiUrl = 'https://reolink.dev';
    
};

export default reolinkApiUrl;



// WEBPACK FOOTER //
// ./src/config/reolinkApiUrl.js